import { Device } from 'DeviceUtils';
import SettingsPage from './SettingsPage';
import SettingsTablet from './SettingsPage.tablet';

const Settings = Device.isTabletOrWeb ? SettingsTablet : SettingsPage;

export { Settings };
